/*
  Custom Logo (owner redesign 2026-10-09; uploads rebuilt for owner addendum 5, item 2, 2026-10-10). Shared by the three
  personalization flows (snippets/personalization-flow-v2.liquid, -watch-roll.liquid, -metal-wallet.liquid); each flow calls
  AscotLogoSides.apply() from its applySideModes() and AscotLogoSides.check() from its checkSideModes().

  Under Custom Logo every engraved side keeps its own text field. Under the fields there is ONE "Upload logo" button, which
  takes up to 3 files:
    - each file row shows its name, a set of side checkboxes when the chosen Engraving option has two or more sides (only those
      sides; one file starts on the first side only, a later file on the first side without a logo) and Remove; a file keeps
      at least one side; a side without a logo uses its text (owner messages 58 and 59, 2026-10-10).
  A side that has a logo keeps its text field, "Text with the logo (optional)". At least one file is required, or Add to cart
  is refused with a message under the button. "+ Notes (optional)" opens a field for the engraver. Nothing empty is sent:
  every optional input carries data-optional-side and assets/ascot-unify.js drops it while empty.

  Order properties, only for filled sides: "<Side> engraving" (the text, as with every design) and, for every side a file was
  put on, "<Side> logo" = the file name(s) ("Front logo: IMG_2599.png", the same form on every side). The uploaded files go as
  private properties "_Logo file 1" to "_Logo file 3": Shopify stores and links them on the order and in the admin, and the
  cart and checkout hide underscore keys, so the cart lines read the same on every side. Then "Notes".

  The file inputs live in a store outside the flow (a hidden element at the end of the body, tied to the product form by its
  form attribute), because the flows re-render their markup on variant changes and a re-rendered file input loses its file.
*/
(function () {
  if (window.AscotLogoSides) return;
  var MSG = 'Upload a logo, or pick a design instead of Custom Logo.';
  var ACCEPT = '.ai,.svg,.png,.pdf,application/postscript,application/illustrator,image/svg+xml,image/png,application/pdf'; // owner 2026-10-12: AI, SVG, PNG, PDF
  var MAX_FILES = 3;
  var states = new WeakMap(); var all = [];

  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function storeFor(formId) {
    var id = 'ascot-logo-store-' + formId; var s = document.getElementById(id);
    if (!s) { s = document.createElement('div'); s.id = id; s.hidden = true; s.setAttribute('data-ascot-logo-store', ''); document.body.appendChild(s); }
    return s;
  }
  // the owner's own placeholder for a side (custom.personalization_config "field_rules", data-field-rules on the v2 flow root)
  function ruleFor(st, side) { var r = null; try { r = JSON.parse((st.root && st.root.getAttribute('data-field-rules')) || 'null'); } catch (e) { r = null; } var e = r && r[String(side || '').toLowerCase()]; return e && e.placeholder ? String(e.placeholder) : ''; }
  function fileInputs(st) { return [].slice.call(storeFor(st.formId).querySelectorAll('input[type="file"][data-ascot-logo-file]')); }
  function filled(st) { return fileInputs(st).filter(function (i) { return i.files && i.files.length; }); }
  function sideNames(st) { return st.sides.map(function (s) { return s.name; }); }

  function newFileInput(st) {
    var i = document.createElement('input');
    i.type = 'file'; i.accept = ACCEPT; i.name = 'properties[_Logo file]';
    i.setAttribute('form', st.formId); i.setAttribute('data-optional-side', ''); i.setAttribute('data-ascot-logo-file', '');
    i.addEventListener('change', function () {
      // owner addendum 6 (item 2b): the same file twice (same name and size) is refused with one short line
      var f0 = i.files && i.files[0];
      var dup = f0 && filled(st).some(function (x) { return x !== i && x.files[0].name === f0.name && x.files[0].size === f0.size; });
      var note = st.root.querySelector('[data-ascot-logo-dup]');
      if (dup) { i.value = ''; if (note) { note.hidden = false; clearTimeout(st.dupTimer); st.dupTimer = setTimeout(function () { note.hidden = true; }, 6000); } render(st); return; }
      if (note) note.hidden = true;
      // a second or third file goes to the first side that has none yet
      if (i.files && i.files.length && !i.getAttribute('data-assign')) {
        var used = [].concat.apply([], filled(st).filter(function (x) { return x !== i; }).map(function (x) { return (x.getAttribute('data-assign') || '').split(','); }));
        var names = sideNames(st); var free = names.filter(function (n) { return used.indexOf(n) < 0; })[0];
        i.setAttribute('data-assign', free || names[0] || '');
      }
      render(st);
    });
    storeFor(st.formId).appendChild(i); return i;
  }

  // a side's text field sits in a row wrapper (kept so the field keeps its own placeholder and required state to restore)
  function ensureRow(st, s) {
    var input = s.input; if (!input) return null;
    var row = input.closest('[data-ascot-logo-row]');
    if (!row) {
      row = document.createElement('div'); row.className = 'ascot-logo-row'; row.setAttribute('data-ascot-logo-row', ''); row.setAttribute('data-side', s.name);
      input.parentNode.insertBefore(row, input); row.appendChild(input);
      if (!input.hasAttribute('data-ascot-ph')) input.setAttribute('data-ascot-ph', input.getAttribute('placeholder') || '');
      if (!input.hasAttribute('data-ascot-req')) input.setAttribute('data-ascot-req', input.required ? '1' : '0');
    }
    return row;
  }
  function unwrap(input) {
    var row = input && input.closest('[data-ascot-logo-row]'); if (!row) return;
    row.parentNode.insertBefore(input, row); row.remove();
    if (input.hasAttribute('data-ascot-ph')) { input.setAttribute('placeholder', input.getAttribute('data-ascot-ph')); input.removeAttribute('data-ascot-ph'); }
    if (input.hasAttribute('data-ascot-req')) { input.required = input.getAttribute('data-ascot-req') === '1'; input.removeAttribute('data-ascot-req'); }
    input.removeAttribute('data-optional-side'); input.setCustomValidity('');
  }

  // the one upload block, under the last side's field
  function ensureBlock(st) {
    var last = st.sides[st.sides.length - 1]; var row = last && last.input.closest('[data-ascot-logo-row]'); if (!row) return null;
    var block = st.root.querySelector('[data-ascot-logo-block]');
    if (!block) {
      block = document.createElement('div'); block.className = 'ascot-logo-block'; block.setAttribute('data-ascot-logo-block', '');
      block.innerHTML = '<button type="button" class="button button--outline ascot-logo-btn" data-ascot-logo-upload aria-label="Upload a logo file">Upload logo</button>' +
        '<p class="text-xs ascot-logo-hint" data-ascot-logo-hint hidden>Add your logo file</p>' +
        '<p class="text-xs ascot-logo-error" data-ascot-logo-dup role="status" hidden>This file is already added</p>' +
        '<ul class="ascot-logo-files" data-ascot-logo-files hidden></ul>';
    }
    if (row.nextElementSibling !== block) row.after(block);
    return block;
  }

  function ensureNotes(st) {
    var host = st.notesHost; if (!host) return null;
    var wrap = host.querySelector('[data-ascot-logo-notes]');
    if (!wrap) {
      wrap = document.createElement('div'); wrap.className = 'ascot-logo-notes'; wrap.setAttribute('data-ascot-logo-notes', '');
      var id = 'ascot-logo-notes-' + st.formId;
      wrap.innerHTML = '<button type="button" class="ascot-logo-notes__toggle link text-sm" data-ascot-notes-toggle aria-expanded="false" aria-controls="' + id + '">+ Notes (optional)</button>' +
        '<textarea id="' + id + '" class="input" rows="3" name="properties[Notes]" form="' + esc(st.formId) + '" data-optional-side data-ascot-notes hidden autocomplete="off" autocorrect="on" autocapitalize="sentences" spellcheck="true" aria-label="Notes for the engraver (optional)" placeholder="Placement, size, or which logo goes on which side"></textarea>';
      host.appendChild(wrap);
      var ta = wrap.querySelector('textarea'); ta.value = st.notes || '';
      ta.addEventListener('input', function () { st.notes = ta.value; });
      wrap.querySelector('[data-ascot-notes-toggle]').addEventListener('click', function () { st.notesOpen = !st.notesOpen; render(st); if (st.notesOpen) ta.focus(); });
    }
    return wrap;
  }

  function render(st) {
    if (!st.logoMode || !st.sides.length) return;
    var names = sideNames(st); var files = filled(st);
    // the sides each file is on (a comma list); sides no longer engraved drop out, and a file always keeps at least one side
    var sidesOf = function (i) { var a = (i.getAttribute('data-assign') || '').split(',').filter(function (x) { return names.indexOf(x) >= 0; }); if (!a.length) a = [names[0]]; i.setAttribute('data-assign', a.join(',')); return a; };
    var bySide = {};
    files.forEach(function (i, k) { i.name = 'properties[_Logo file ' + (k + 1) + ']'; sidesOf(i).forEach(function (sd) { (bySide[sd] = bySide[sd] || []).push(i.files[0].name); }); });
    var withLogo = {}; Object.keys(bySide).forEach(function (sd) { withLogo[sd] = true; });
    // one plain line per side with a logo, "<Side> logo" = the file name(s); no line for a side the shopper did not choose
    var store = storeFor(st.formId);
    [].slice.call(store.querySelectorAll('input[data-ascot-logo-same], input[data-ascot-logo-line]')).forEach(function (x) { x.remove(); });
    names.forEach(function (sd) { if (!bySide[sd]) return; var h = document.createElement('input'); h.type = 'hidden'; h.setAttribute('form', st.formId); h.setAttribute('data-ascot-logo-line', ''); h.setAttribute('data-optional-side', ''); h.name = 'properties[' + sd + ' logo]'; h.value = bySide[sd].join(', '); store.appendChild(h); });
    st.sides.forEach(function (s) {
      if (!ensureRow(st, s)) return;
      var input = s.input;
      input.disabled = false; input.hidden = false; input.style.display = ''; input.required = false; input.setAttribute('data-optional-side', '');
      if (input.hasAttribute('maxlength') && !input.hasAttribute('data-owner-limit')) input.removeAttribute('maxlength');
      input.setAttribute('placeholder', withLogo[s.name] ? window.AscotPlaceholders.LOGO : (ruleFor(st, s.name) || window.AscotPlaceholders.forSide(s.name, window.AscotPlaceholders.textTypeIn(st.root))));
    });
    var block = ensureBlock(st);
    if (block) {
      var up = block.querySelector('[data-ascot-logo-upload]'); up.hidden = files.length >= MAX_FILES;
      var list = block.querySelector('[data-ascot-logo-files]');
      list.innerHTML = files.map(function (i, k) {
        var on = (i.getAttribute('data-assign') || '').split(',');
        // owner addendum 7 (item 3): with two or more sides, the sides this file goes on, as checkboxes
        var picker = names.length > 1 ? '<span class="ascot-logo-sides" role="group" aria-label="Sides for ' + esc(i.files[0].name) + '">' + names.map(function (n) { return '<label class="ascot-logo-sidechk"><input type="checkbox" data-ascot-logo-sidechk data-slot="' + k + '" value="' + esc(n) + '"' + (on.indexOf(n) >= 0 ? ' checked' : '') + '><span>' + esc(n) + '</span></label>'; }).join('') + '</span>' : '';
        return '<li class="ascot-logo-file"><span class="ascot-logo-file__name">' + esc(i.files[0].name) + '</span>' + picker + '<button type="button" class="link text-sm ascot-logo-remove" data-ascot-logo-remove data-slot="' + k + '" aria-label="Remove ' + esc(i.files[0].name) + '">Remove</button></li>';
      }).join('');
      list.hidden = !files.length;
    }
    var notes = ensureNotes(st);
    if (notes) {
      var ta = notes.querySelector('textarea'); var tg = notes.querySelector('[data-ascot-notes-toggle]');
      ta.hidden = !st.notesOpen; ta.style.display = st.notesOpen ? '' : 'none'; ta.disabled = false; tg.setAttribute('aria-expanded', String(!!st.notesOpen));
      // owner addendum 2026-10-10 (item 4): collapsed by default, + when closed and a minus sign when open
      tg.textContent = (st.notesOpen ? '−' : '+') + ' Notes (optional)';
    }
    check(st.root, false);
  }

  function onClick(st, e) {
    var b = e.target.closest('[data-ascot-logo-upload], [data-ascot-logo-remove]');
    if (!b || !st.root.contains(b)) return;
    if (b.matches('[data-ascot-logo-upload]')) {
      if (filled(st).length >= MAX_FILES) return;
      var free = fileInputs(st).filter(function (i) { return !(i.files && i.files.length); })[0] || newFileInput(st);
      free.click(); return;
    }
    if (b.matches('[data-ascot-logo-remove]')) {
      var f = filled(st)[parseInt(b.getAttribute('data-slot'), 10)]; if (f) f.remove();
      render(st);
    }
  }
  function onChange(st, e) {
    var box = e.target.closest && e.target.closest('[data-ascot-logo-sidechk]'); if (!box || !st.root.contains(box)) return;
    var slot = box.getAttribute('data-slot'); var f = filled(st)[parseInt(slot, 10)]; if (!f) return;
    var picked = [].slice.call(st.root.querySelectorAll('[data-ascot-logo-sidechk][data-slot="' + slot + '"]')).filter(function (c) { return c.checked; }).map(function (c) { return c.value; });
    // a file keeps at least one side: unticking the last one puts it back
    if (!picked.length) { box.checked = true; picked = [box.value]; }
    f.setAttribute('data-assign', picked.join(','));
    render(st);
  }

  // ctx: { root, formId, logoMode, sides: [{ name, input }], notesHost, legacy: [elements to keep hidden and disabled] }
  function apply(ctx) {
    var st = states.get(ctx.root);
    if (!st) {
      st = { root: ctx.root, formId: ctx.formId, sides: [], notes: '', notesOpen: false, touched: [] };
      states.set(ctx.root, st); all.push(st);
      ctx.root.addEventListener('click', function (e) { onClick(st, e); });
      ctx.root.addEventListener('change', function (e) { onChange(st, e); });
    }
    st.formId = ctx.formId; st.notesHost = ctx.notesHost || null;
    // sides that are no longer engraved, or every side when leaving Custom Logo: back to the plain field
    st.touched.forEach(function (input) { if (!ctx.logoMode || !(ctx.sides || []).some(function (s) { return s.input === input; })) unwrap(input); });
    [].slice.call(storeFor(st.formId).querySelectorAll('input')).forEach(function (i) { i.disabled = !ctx.logoMode; });
    (ctx.legacy || []).forEach(function (el) { if (!el) return; el.hidden = true; [].slice.call(el.querySelectorAll ? el.querySelectorAll('input, textarea, select') : []).forEach(function (f) { f.disabled = true; f.required = false; }); });
    [].slice.call(ctx.root.querySelectorAll('[data-logo-on]')).forEach(function (el) { el.disabled = true; });
    st.logoMode = !!ctx.logoMode; st.sides = st.logoMode ? (ctx.sides || []).filter(function (s) { return s.input; }) : [];
    st.touched = st.sides.map(function (s) { return s.input; });
    if (!st.logoMode || !st.sides.length) {
      var notes = st.notesHost && st.notesHost.querySelector('[data-ascot-logo-notes]'); if (notes) notes.remove(); st.notesOpen = false;
      var blk = ctx.root.querySelector('[data-ascot-logo-block]'); if (blk) blk.remove();
      var m = ctx.root.querySelector('[data-ascot-logo-error]'); if (m) m.remove();
      return;
    }
    render(st);
  }

  // at least one logo file; the message under the upload block when asked, and the first side's validity either way
  function check(root, show) {
    var st = states.get(root); if (!st || !st.logoMode || !st.sides.length) return true;
    var ok = filled(st).length > 0;
    var block = root.querySelector('[data-ascot-logo-block]');
    var msg = root.querySelector('[data-ascot-logo-error]');
    if (!ok && !msg && block) { msg = document.createElement('p'); msg.className = 'text-xs ascot-logo-error'; msg.setAttribute('data-ascot-logo-error', ''); msg.textContent = MSG; msg.hidden = true; block.after(msg); }
    if (msg) msg.hidden = ok || !show;
    // owner addendum 2 (item 6): one muted line under Upload logo while no file is attached; it gives way to the message above
    var hint = block && block.querySelector('[data-ascot-logo-hint]');
    if (hint) hint.hidden = ok || !!(msg && !msg.hidden);
    st.sides.forEach(function (s, k) { s.input.setCustomValidity(!ok && k === 0 ? MSG : ''); });
    if (!ok && show) { var btn = block && block.querySelector('[data-ascot-logo-upload]'); if (btn) { btn.scrollIntoView({ block: 'center' }); btn.focus({ preventScroll: true }); } }
    return ok;
  }
  // the store's own validation (assets/ascot-unify.js, AscotValidation) asks here first: a side field that is invalid only
  // because no logo is attached shows the logo message under the upload block, not a "Required." line under the field
  function showFor(input) {
    for (var k = 0; k < all.length; k++) { var st = all[k]; if (st.logoMode && st.sides.some(function (s) { return s.input === input; })) { check(st.root, true); return st.root.querySelector('[data-ascot-logo-block]') || true; } }
    return null;
  }

  // OWNER LIMITS (owner rule 2026-10-09): a field limited by the owner (data-owner-limit, maxlength from the product's own
  // custom.personalization_config) shows a counter inside the field on the right from 80 percent of its limit ("38/40"), and
  // at the limit a short muted line under it ("40 character limit"). No field stops accepting characters silently.
  function limitCounter(input) {
    var max = input.maxLength; if (!(max > 0) || !input.hasAttribute('data-owner-limit')) return;
    var wrap = input.parentNode && input.parentNode.matches && input.parentNode.matches('[data-ascot-limit-wrap]') ? input.parentNode : null;
    if (!wrap) { wrap = document.createElement('span'); wrap.className = 'ascot-limit-wrap'; wrap.setAttribute('data-ascot-limit-wrap', ''); input.parentNode.insertBefore(wrap, input); wrap.appendChild(input); }
    var count = wrap.querySelector('[data-ascot-limit-count]');
    if (!count) { count = document.createElement('span'); count.className = 'ascot-limit-count'; count.setAttribute('data-ascot-limit-count', ''); count.setAttribute('aria-hidden', 'true'); wrap.appendChild(count); }
    var note = wrap.nextElementSibling && wrap.nextElementSibling.matches('[data-ascot-limit-note]') ? wrap.nextElementSibling : null;
    if (!note) { note = document.createElement('p'); note.className = 'text-xs ascot-limit-note'; note.setAttribute('data-ascot-limit-note', ''); note.setAttribute('aria-live', 'polite'); wrap.after(note); }
    var n = input.value.length; var show = n >= Math.ceil(max * 0.8);
    count.textContent = n + '/' + max; count.hidden = !show; input.classList.toggle('ascot-limit-near', show);
    note.textContent = max + ' character limit'; note.hidden = n < max;
  }
  document.addEventListener('input', function (e) { if (e.target && e.target.matches && e.target.matches('input[data-owner-limit], textarea[data-owner-limit]')) limitCounter(e.target); });
  document.addEventListener('focusin', function (e) { if (e.target && e.target.matches && e.target.matches('input[data-owner-limit], textarea[data-owner-limit]')) limitCounter(e.target); });

  window.AscotLogoSides = { apply: apply, check: check, showFor: showFor, message: MSG, limitCounter: limitCounter, maxFiles: MAX_FILES };
})();

/*
  Placeholders, owner rule 2026-10-09 (docs/run/next-task.md messages 22 and 23), every listing and every flow. Placeholders
  only: no helper text under an input, and never a character limit.
  - the front or main side: the selected design's text_type ("Initials", "Name", "Name and date", "Two names and a date",
    "Short message" for a quote design; a "none" design has no front field at all, see applyArtworkOnly in the v2 flow),
    and "Name or initials" for a design without one;
  - the back, and any box or lid field: "Name, initials or a short message";
  - beside an uploaded logo (Custom Logo): "Text with the logo (optional)".
  A design carries its text_type as data-design-text-type on its picker option (custom.designs "text_type", or the design
  map); the flows ask AscotPlaceholders.forSide(location, textType).
*/
(function () {
  if (window.AscotPlaceholders) return;
  var MAIN = 'Name or initials', SECOND = 'Name, initials or a short message', LOGO = 'Text with the logo (optional)';
  var BY_TYPE = { initials: 'Initials', name: 'Name', name_and_date: 'Name and date', two_names_and_date: 'Two names and a date', message: 'Short message' };
  function isSecond(location) { var w = String(location || '').toLowerCase().split(/[^a-z]+/); return w[0] === 'back' || w.indexOf('box') >= 0 || w.indexOf('lid') >= 0; }
  // U5 (owner 2026-10-18, his queue item 3: "Cigar cases (metal, ostrich, leather, travel cases): placeholder 'Name / short message' instead of
  // 'Short message'"): the flow root of a cigar case carries data-message-placeholder (snippets/personalization-flow-v2.liquid)
  function messageText() { var e = document.querySelector('.shopify-section--main-product [data-message-placeholder]'); var v = e ? (e.getAttribute('data-message-placeholder') || '').trim() : ''; return v || BY_TYPE.message; }
  function forSide(location, textType) { if (isSecond(location)) return SECOND; var t = String(textType || '').trim().toLowerCase(); if (t === 'message') return messageText(); return BY_TYPE[t] || MAIN; }
  // the text_type of the design the shopper has chosen in a flow (its checked radio or selected picker option)
  function textTypeIn(root) {
    if (!root) return '';
    var opt = root.querySelector('[data-design-option].is-selected[data-design-text-type], [data-design-option][aria-selected="true"][data-design-text-type]');
    if (opt) return opt.getAttribute('data-design-text-type') || '';
    var radio = root.querySelector('input[type="radio"]:checked[data-design-text-type]');
    return radio ? radio.getAttribute('data-design-text-type') || '' : '';
  }
  window.AscotPlaceholders = { MAIN: MAIN, SECOND: SECOND, LOGO: LOGO, isSecond: isSecond, forSide: forSide, textTypeIn: textTypeIn };
})();
